<div class="errorMessageWraper" [class.noTopLine]="noTopLine" [class.active]="errorMessage.length" [class.employerStage]="employerStage">
  @for (msg of errorMessage; track msg) {
    <span class="singleErrorMessage">{{ getMessage(msg) | translate: msg.arguments }}</span>
  }
</div>
